import EditFieldModal from './EditFieldModal';
import { UseEditFieldResult } from './useEditField';

/**
 * Modal edycji pozycji podpięty pod wynik `useEditField`.
 *
 * Trzy ekrany operatora renderowałyby dokładnie ten sam blok warunkowy —
 * `key` po identyfikatorze wiersza wymusza świeży `useForm` przy każdym
 * otwarciu, bo `defaultValues` czyta się tylko przy montowaniu.
 */
const EditFieldModalHost = ({
  editField,
}: {
  editField: UseEditFieldResult;
}) => {
  const { target } = editField;

  if (!target) {
    return null;
  }

  return (
    <EditFieldModal
      key={target.row.id}
      row={target.row}
      sectionTitle={target.sectionTitle}
      type={target.type}
      fields={target.fields}
      options={target.options}
      tourId={target.tourId}
      seatRefs={target.seatRefs}
      withAmount={target.withAmount}
      defaultValues={target.defaultValues}
      discount={target.discount}
      isSaving={editField.isSaving}
      onSubmit={editField.submit}
      onRemove={target.canRemove ? editField.remove : undefined}
      onClose={editField.close}
    />
  );
};

export default EditFieldModalHost;
